export function categoryForLayer(categoryNames) {
  let categoryCount = 1;
  const categoryItems = categoryNames.reduce((acc, item) => {
    if (item && item?.toLowerCase() !== "category" && item !== "product") {
      acc[`item_category${categoryCount}`] = item;
      categoryCount++;
    }
    return acc;
  }, {});

  return categoryItems;
}
